import { render, staticRenderFns } from "./DynamicFormPage.vue?vue&type=template&id=505c9bde&scoped=true"
import script from "./DynamicFormPage.vue?vue&type=script&lang=js"
export * from "./DynamicFormPage.vue?vue&type=script&lang=js"
import style0 from "./DynamicFormPage.vue?vue&type=style&index=0&id=505c9bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505c9bde",
  null
  
)

export default component.exports